<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalDraggable]=false [modalHelpIndex]="helpIndex">

    <div class="discover-fields-full-controls">
        <div class="discover-fields-left-side-controls">
            <div class="top-text right-border">Load File</div>
            <res-connector-picker (getPath)="getPath($event)" [treeHeaderText]="'Folder'" [filterConnectors]="true"></res-connector-picker>
        </div>
        <div class="discover-fields-middle-side-controls" [hidden]="hideSettingsPanel()">
            <div class="top-text">Settings</div>
            <div class="settings-encoding">
                <div class="modal-row">
                    <div>
                        <label>Encoding:</label>
                    </div>
                    <div class="delimiter-select">
                        <select [(ngModel)]="selectedEncoding"
                            data-automation-id="load-file-import-discover-fields-encoding-option'"
                            class="delimiter-select-input">
                            <option *ngFor="let code of encodingTypes" [ngValue]="code">{{code.name}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="settings-panel-header">Delimiters</div>

            <button type="button" data-automation-id="load-file-import-discover-fields-dat-defaults-button"
                class="secondary-button btn-margin btn-padding" (click)="setDelimiterDefaults('dat')">DAT
                Defaults</button>
            <button type="button" data-automation-id="load-file-import-discover-fields-csv-defaults-button"
                class="secondary-button btn-padding" (click)="setDelimiterDefaults('csv')">CSV Defaults</button>


            <div class="modal-row" *ngFor="let delimiter of delimiters">
                <div>
                    <label>{{delimiter.name}}: </label>
                </div>
                <div class="delimiter-select">
                    <select [(ngModel)]="selectedSpecialChars[delimiter.field]"
                        [attr.data-automation-id]="modalAutomationId + '-' + delimiter.field + '-option'"
                        class="delimiter-select-input">
                        <option *ngFor="let char of filter(specialCharacters)" [ngValue]="char">{{char.name}}</option>
                    </select>
                </div>
            </div>


            <button type="button" data-automation-id="load-file-import-discover-fields-update-preview-button"
                class="secondary-button update-preview" (click)="updatePreview()"><i class="fa fa-refresh"></i>Update
                Preview</button>
        </div>
        <div class="discover-fields-right-side-controls">
            <div class="top-text">Preview</div>
            <div class="previewGrid">
                <res-generic-grid id="previewGrid" class="modal-fill" [gridName]="previewGridName"
                    [automationId]="modalAutomationId" [helpIndex]="helpIndex" [rowSelection]="rowSelection"
                    [(isBusy)]="isPreviewBusy" [(isBusyMessage)]="isBusyPreviewMessage" [columnDefs]="previewColumnDefs"
                    [requestInfo]="previewRequestInfo" [responseArrayCallback]="previewResponseArrayCallback"
                    [responseCallback]="previewResponseCallback" [pagerVisible]="false">
                </res-generic-grid>
            </div>
        </div>
    </div>
</res-base-modal>